exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pro_cart_item[data-v-0ce937aa] {\n  border-bottom: solid 1px #d0d0d0;\n  min-height: 70px;\n  padding: 23px 20px;\n}\n.pro_cart_item[data-v-0ce937aa]:last-child {\n  border-bottom: none;\n}\n.pro_cart_img[data-v-0ce937aa] {\n  width: 50px;\n}\n.pro_cart_desc[data-v-0ce937aa] {\n  width: 180px;\n}\n.pro_cart_qty[data-v-0ce937aa] {\n  width: 30px;\n}\n", ""]);

// exports
